<ng-container *ngIf="!isLoading; else loading">
  <ng-container *ngIf="!isForbiddenLink; else tokenExpirado">
    <mat-card style="padding: 30px" class="card">
      <form [formGroup]="form" (ngSubmit)="onRegister()">
        <div class="logo">
          <img src="assets/logoRegister.png" class="imgLogo" />
        </div>

        <div class="row">
          <span class="col-12" *ngIf="payload.cnpj">
            <mat-form-field appearance="outline">
              <mat-label>CNPJ</mat-label>
              <input
                matInput
                formControlName="cpf"
                class="full-width"
                [specialCharacters]="cnpjSpecialCharacters"
                [mask]="cnpjMask"
              />

              <mat-error *ngIf="!hasGroupError()">
                {{ getControlErrorMessage("cpf") }}
              </mat-error>
            </mat-form-field>
          </span>

          <span class="col-12" *ngIf="!payload.cnpj">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>CPF</mat-label>
              <input
                matInput
                formControlName="cpf"
                [specialCharacters]="['.', '-']"
                mask="000.000.000-00"
              />
              <mat-error *ngIf="!hasGroupError()">
                {{ getControlErrorMessage("cpf") }}
              </mat-error>
            </mat-form-field>
          </span>
        </div>

        <div class="row">
          <span class="col-12">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Nome Completo</mat-label>
              <input matInput formControlName="name" />

              <mat-error *ngIf="!hasGroupError()">
                {{ getControlErrorMessage("name") }}
              </mat-error>
            </mat-form-field>
          </span>

          <span class="col-12">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>E-mail</mat-label>
              <input matInput formControlName="email" />

              <mat-error *ngIf="!hasGroupError()">
                {{ getControlErrorMessage("email") }}
              </mat-error>
            </mat-form-field>
          </span>
        </div>

        <div class="row">
          <span class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>Senha</mat-label>
              <div class="d-flex flex-row justify-content-between">
                <input
                  matInput
                  [type]="hidePassword ? 'password' : 'text'"
                  formControlName="password"
                />
                <button
                  mat-icon-button
                  matSuffix
                  class="show-password-btn"
                  (click)="hidePassword = !hidePassword"
                >
                  <fa-icon
                    [icon]="hidePassword ? 'eye-slash' : 'eye'"
                  ></fa-icon>
                </button>
              </div>

              <mat-error *ngIf="!hasGroupError()">
                {{ getControlErrorMessage("password") }}
              </mat-error>
            </mat-form-field>
          </span>

          <span class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>Confirmar Senha</mat-label>
              <div class="d-flex flex-row justify-content-between">
                <input
                  matInput
                  [type]="hidePasswordConfirm ? 'password' : 'text'"
                  formControlName="passwordConfirm"
                />
                <button
                  mat-icon-button
                  matSuffix
                  class="show-password-btn"
                  (click)="hidePasswordConfirm = !hidePasswordConfirm"
                >
                  <fa-icon
                    [icon]="hidePasswordConfirm ? 'eye-slash' : 'eye'"
                  ></fa-icon>
                </button>
              </div>

              <mat-error *ngIf="!hasGroupError()">
                {{ getControlErrorMessage("passwordConfirm") }}
              </mat-error>
            </mat-form-field>
          </span>
        </div>

        <div class="actions">
          <button
            mat-button
            class="btn-green btn-large"
            type="submit"
            [disabled]="!form.valid"
          >
            <span>Criar Usuário</span>
          </button>
        </div>
      </form>
    </mat-card>
  </ng-container>
</ng-container>

<ng-template #tokenExpirado>
  <mat-card style="padding: 30px" class="card text-center">
    <div class="logo">
      <img src="assets/logoRegister.png" class="imgLogo" />
    </div>
    <h3 class="text-danger">Link Inválido ou Expirado</h3>
    <p>
      O link que você tentou acessar está expirado ou é inválido. Entre em
      contato com o suporte ou solicite um novo link.
    </p>

    <a mat-button class="btn-green btn-large" [routerLink]="['/', 'login']">
      <span>Ir para login</span>
    </a>
  </mat-card>
</ng-template>

<ng-template #loading>
  <mat-card style="padding: 500px" class="card text-center">
    <div class="logo">
      <img src="assets/logoRegister.png" class="imgLogo" />
    </div>
  </mat-card>

  <div class="overlay bottom">
    <mat-spinner diameter="60" class="spinner-overlay"> </mat-spinner>
    <span>
      Consultando dados da conta, aguarde um momento
      <span class="ellipsis"></span>
    </span>
  </div>
</ng-template>
